import { Injectable } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';

import { EnvUtils } from '@ecm/dispatcher';
import { ContextService, PortfolioService } from '@ecm/portfolio';

import { ElcosService } from './elcos.service';
import { RouterService } from './router.service';

@Injectable({
    providedIn: 'root',
})
export class BrandService {
    private lastBrandWasSosh: boolean;

    public constructor(
        private readonly routerService: RouterService,
        private readonly elcosService: ElcosService,
        private readonly contextService: ContextService,
        private readonly portfolioService: PortfolioService,
    ) {}

    /**
     * @deprecated : This method should only be called from AppComponent and will be replaced by a store/selector
     */
    public isSosh(): Observable<boolean> {
        return this.routerService.isCurrentRouteSosh().pipe(
            tap((isSosh: boolean) => {
                if (!EnvUtils.isEclair()) {
                    if (this.lastBrandWasSosh !== isSosh) {
                        this.loadElcosForBrand(isSosh ? 'sosh' : 'orange');
                    }
                    this.lastBrandWasSosh = isSosh;
                }
            }),
        );
    }

    private loadElcosForBrand(brand: 'orange' | 'sosh'): void {
        if (brand === 'sosh') {
            return this.elcosService.switchToSosh();
        }

        this.contextService
            .isAuthenticated()
            .pipe(
                switchMap((auth) => {
                    if (!auth) {
                        this.elcosService.switchToOrange();
                        return of(null);
                    }

                    return this.portfolioService.getLoggedContract().pipe(
                        tap((contract) => {
                            if (contract?.contractInstallationArea?.geographicalArea === 'ORM') {
                                if (contract?.contractInstallationArea?.departmentLabel === 'MAYOTTE') {
                                    this.elcosService.switchToOrangeMayotte();
                                } else {
                                    this.elcosService.switchToOrangeReunion();
                                }
                            } else if (contract?.contractInstallationArea?.geographicalArea === 'OAG') {
                                this.elcosService.switchToOrangeCaribbean();
                            } else {
                                this.elcosService.switchToOrange();
                            }
                        }),
                    );
                }),
            )
            .subscribe();
    }
}
